import React from 'react';
import { FadeIn } from './FadeIn';
export function CostComparison() {
  const comparisons = [{
    without: 'Sesiones improvisadas sin protocolo',
    cost: 'Tensión acumulada y relación dañada'
  }, {
    without: 'Bloqueos sin detectar ni trabajar',
    cost: 'Creencias negativas que se instalan'
  }, {
    without: 'Métodos de YouTube que se contradicen',
    cost: 'Más confusión y menos confianza'
  }, {
    without: 'Sin frases correctas para cada momento',
    cost: 'Peleas que se repiten cada tarde'
  }, {
    without: 'Sin seguimiento del progreso',
    cost: 'Sin saber si mejora o no'
  }, {
    without: 'Sin rutina fija',
    cost: 'Avances que se pierden en una semana'
  }, {
    without: 'Sin cierre positivo',
    cost: 'Cada sesión deja un recuerdo negativo'
  }, {
    without: 'Sin diagnóstico del bloqueo real',
    cost: 'Ayuda que no llega al problema real'
  }];
  return <section className="py-12 md:py-16 relative bg-background" data-id="element-77">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-78">
        <FadeIn data-id="element-79">
          <div className="text-center mb-8" data-id="element-80">
            <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-slate-900" data-id="element-81">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-82">
          <div className="bg-white rounded-3xl border border-slate-200 overflow-hidden mb-8 shadow-soft-lg" data-id="element-83">
            <div className="grid grid-cols-2 bg-surfaceLight/50 p-4 md:p-6 border-b border-slate-200" data-id="element-84">
              <div className="font-bold text-slate-500 uppercase tracking-widest text-[10px] md:text-xs" data-id="element-85">
                Sin el MegaPack Matemáticas Sin Lágrimas
              </div>
              <div className="font-bold text-coral-dark uppercase tracking-widest text-[10px] md:text-xs pl-4 md:pl-6 border-l border-slate-200" data-id="element-86">
                Costo real
              </div>
            </div>
            <div className="divide-y divide-slate-100" data-id="element-87">
              {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 hover:bg-slate-50/50 transition-colors" data-id="element-88">
                  <div className="text-slate-700 pr-4 font-medium text-sm md:text-base" data-id="element-89">
                    {item.without}
                  </div>
                  <div className="text-coral pl-4 md:pl-6 border-l border-slate-100 font-bold text-sm md:text-base" data-id="element-90">
                    {item.cost}
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-91">
          <div className="mt-8 text-center max-w-3xl mx-auto" data-id="element-92">
            <p className="text-xl md:text-2xl text-primary-dark font-heading font-extrabold mb-3" data-id="element-93">
              El próximo ejercicio puede ser diferente.
            </p>
            <p className="text-base text-slate-600 font-medium italic" data-id="element-94">
              🎓 "Desde hoy, la hora de la tarea de matemáticas tiene sistema."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}